import { createRouter, NavigateFn } from "@tanstack/react-router"
import { routeTree } from "./routeTree.gen"
import { TFunction } from "i18next"
import { QueryClient } from "@tanstack/react-query"
import { AuthStatus } from "./@client/Theasoft_ApiServer_Authentication"
import { UseTranslationsReturn } from "./utils/use-t"
import { NotFoundAndLegacyRedirect } from "./NotFoundAndLegacyRedirect"

export interface RouterContext {
  getTitle?: () => string
  authStatus?: AuthStatus
  t: TFunction<"app_server", undefined>
  ts: UseTranslationsReturn
  queryClient: QueryClient
  navigate: NavigateFn | undefined
}

export const router = createRouter({
  routeTree,
  // context is set on all routes in router provider (Router.tsx)
  context: {} as RouterContext,
  defaultNotFoundComponent: NotFoundAndLegacyRedirect,
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data.action === "redirect" && event.data.url) {
      router.navigate({ to: event.data.url })
    }
  })
}
